// src/oura/lib/visibilityChecks.ts
//
// The check names, the same wherever a check appears (#4870).
//
// ONE DEFINITION. The Visibility screen's type grid, its kind chips and the
// model behind them all name the checks; three copies is three answers to
// "what is this check called", and they drift on the first wording change.
// The count helpers that used to live here went with the Overview check split
// and the old Visibility breakdown: the type grid states each cell as a share
// with its "N of M" underneath.

import type { VisibilityCheckName } from "../audit";

/** Short name for a check, above its own question. */
export const VISIBILITY_CHECK_LABEL: Record<VisibilityCheckName, string> = {
    location: "Location",
    specialty: "Specialty",
    intent: "Intent",
    authority: "Authority",
    pick: "Be the pick",
    source: "Be the source",
    supplier: "Be the supplier",
};
